import { OwnProfileInterface } from "./interfaces/OwnProfileInterface";
import {ProfileField} from "../../types/ProfileField";

export class OwnProfile {
    lastName = '';
    firstName = '';
    position = undefined;
    company = undefined;
    biography = undefined;
    photoFileId = undefined;
    email = '';
    phoneNumber = '';
    [key: string]: any;

    constructor(data: OwnProfileInterface, fields: Array<ProfileField> = []) {
        Object.assign(this, {
            lastName: data.lastName ? data.lastName : '',
            firstName: data.firstName ? data.firstName : '',
            position: data.position ? data.position : undefined,
            company: data.company ? data.company : undefined,
            biography: data.biography ? data.biography : undefined,
            photoFileId: data.photoFileId ? data.photoFileId : undefined,
            email: data.email ? data.email : '',
            phoneNumber: data.phoneNumber ? data.phoneNumber : '',
        });

        fields.map(field => {
            if (field.name in data) {
                this[field.name] = data[field.name];
            }
        })
    }
}